module.exports = __webpack_public_path__ + "img/join_img4.a8f0e25a.jpg";